<template>
  <div class="login-mask">
    <div class="login-box">
      <div class="mb-20" style="display: flex; align-items: center;justify-content: space-between">
        <div></div>
        <div>
          <img
            v-if="DefaultDomain"
            src="@/assets/img/favicon.png"
            class="w-166 h-48"
          />
          <img v-else src="@/assets/img/hqt-text-logo.png" class="w-136 h-48" />
        </div>
        <div class="close" @click="userStore.setShowLogin(false)">
          <el-icon size="24" color="#999">
            <CloseBold />
          </el-icon>
        </div>
      </div>
      <div class="changeLoginTT" v-if="loginType != 'register'">
        <div class="login-tabs">
          <div
            :class="loginType == 'weChat' ? 'tab-item' : 'tab-twe'"
            @click="changeType('weChat')"
          >
            <img
              src="https://res.hangxintong.cn/nxjpWx/icon/icon-wx.png"
              class="tab-icon"
            />
            <span>微信登录</span>
          </div>
          <div
            :class="
              loginType == 'pwd' ||
              loginType == 'forget' ||
              loginType == 'register'
                ? 'tab-item'
                : 'tab-twe'
            "
            @click="changeType('pwd')"
          >
            <img
              src="https://res.hangxintong.cn/nxjpWx/icon/icon-account.png"
              class="tab-icon"
            />
            <span>账号登录</span>
          </div>
          <div
            :class="loginType == 'code' ? 'tab-item' : 'tab-twe'"
            @click="changeType('code')"
          >
            <img
              src="https://res.hangxintong.cn/nxjpWx/icon/icon-code.png"
              class="tab-icon"
            />
            <span>验证码登录</span>
          </div>
        </div>
      </div>
      <PwdLogin v-if="loginType === 'pwd'" @change-login-type="changeType" />
      <!-- 验证码登录 -->
      <CodeLogin v-if="loginType === 'code'" @change-login-type="changeType" />
      <!-- 微信登录 -->
      <WeChatLogin
        v-if="loginType === 'weChat'"
        @change-login-type="changeType"
      />
      <!-- 绑定手机号 -->
      <BindMobile
        v-if="loginType === 'bindMobile'"
        :user-id="userId"
        :set-pwd="setPwd"
        @change-login-type="changeType"
      />
      <!-- 忘记密码 -->
      <Forget v-if="loginType === 'forget'" @change-login-type="changeType" />
      <!-- 注册账号 -->
      <Register
        v-if="loginType === 'register'"
        @change-login-type="changeType"
      />
    </div>
  </div>
</template>
<script setup>
import { useUserStore } from '@/store/modules/user'

const userStore = useUserStore()
const props = defineProps({
  type: {
    type: String,
    default: 'weChat',
  },
  loginType: {
    type: String,
    default: 'weChat',
  },
})
const userId = ref(null)
const setPwd = ref(false)
const DefaultDomain = ref(null)
const openId = ref('')

onMounted(() => {
  console.log(props.loginType, 22222)
  console.log(userStore.getLoginType, 3333333333)
  // 优先使用userStore中的loginType，其次是props传入的值
  loginType.value =
    userStore.getLoginType || props.loginType || props.type || 'weChat'
  console.log(loginType.value)
})

if (localStorage.getItem('DefaultDomain') == 'true') {
  DefaultDomain.value = true
} else {
  DefaultDomain.value = false
}

const loginType = ref('weChat')

// 监听userStore中的loginType变化
watch(
  () => userStore.getLoginType,
  newType => {
    if (newType) {
      loginType.value = newType
    }
  },
  { immediate: true }
)

function changeType(type, otherData, userPhone) {
  console.log(11111111)
  console.log(type, otherData, userPhone)

  switch (type) {
    case 'pwd':
      loginType.value = 'pwd'
      break
    case 'code':
      loginType.value = 'code'
      break
    case 'forget':
      loginType.value = 'forget'
      break
    case 'weChat':
      loginType.value = 'weChat'
      break
    case 'bindMobile':
      if (otherData) {
        userId.value = otherData
        console.log(otherData)
      }
      if (userPhone) {
        setPwd.value = userPhone
      }
      loginType.value = 'bindMobile'
      break
    case 'register':
      loginType.value = 'register'
      break
    default:
      loginType.value = 'weChat'
      break
  }
}
</script>

<style scoped lang="scss">
::-webkit-scrollbar {
  width: 6px;    /* 垂直滚动条宽度（关键） */
  height: 6px;   /* 水平滚动条高度（可选） */
}
.login-tabs {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px;
}

.tab-twe {
  display: flex;
  align-items: center;
  padding: 5px 10px;
  border-radius: 4px;
  width: 33%;
  font-family: PingFangSC-regular;
  color: #000000;
  font-weight: 400;
  font-size: 16px;
  cursor: pointer;
}

.tab-item {
  display: flex;
  align-items: center;
  background: #fff;
  padding: 5px 10px;
  border-radius: 4px;
  width: 33%;
  font-family: PingFangSC-medium;
  color: #000000;
  font-weight: 500;
  font-size: 16px;
  cursor: pointer;
}

.tab-icon {
  width: 25px;
  height: 25px;
  margin-right: 4px;
  margin-top: 2px;
}

.changeLoginTT {
  background: #f1f3f6;
  //margin: 12px 8px;
  border-radius: 4px;
}

.login-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;

  .login-box {
    width: 580px;
    //height: 580px;
    background: #fff;
    // border: 1px solid rgba(187, 187, 187, 1);
    padding: 30px 40px;
    box-sizing: border-box;
    position: relative;
    border-radius: 4px;
    height: 530px;
    overflow: auto;

    .close {
      //position: absolute;
      //top: 20px;
      //right: 20px;
      cursor: pointer;
      margin-top: -40px;
      margin-right: -12px;
    }

    :deep .el-form-item {
      margin-bottom: 28px;
    }
  }
}
</style>
